// helpers/addressUtils.js
export const getStreetName = (fullAddress) => {
    if (!fullAddress) return "";
  
    // Split address into parts separated by commas and take the first segment
    const streetSegment = fullAddress.split(",")[0].trim();
  
    // Split the street segment into words
    const parts = streetSegment.split(" ");
  
    // Check if the first word starts with a number (e.g., "2", "14B", "5th")
    const hasNumberPrefix = /^\d/.test(parts[0]);
  
    // Remove the numeric prefix if present
    return hasNumberPrefix ? parts.slice(1).join(" ") : streetSegment;
  };